"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFolderId = void 0;
var hasFolderId = function (props) {
    return 'folder-id' in props;
};
exports.hasFolderId = hasFolderId;
//# sourceMappingURL=hasFolderId.js.map